import { useState } from 'react';
import Layout from 'components/common/layout/Layout';
import CheckPassword from './CheckPassword';
import MypageInfoForm from './MypageInfoForm';

const Mypage = () => {
  const [passwordCheck, setPasswordCheck] = useState(false);

  return (
    <Layout>
      <h1 className="main_title mt40">마이페이지</h1>

      {!passwordCheck ? (
        <CheckPassword setPasswordCheck={setPasswordCheck} />
      ) : (
        <>
          <p className="mt4 lh24">
            정확한 정보를 등록해 주세요. (<span className="font_red"> *</span>{' '}
            항목은 필수 입력사항입니다.)
          </p>

          <MypageInfoForm />
        </>
      )}
    </Layout>
  );
};
export default Mypage;
